declare namespace $ {

	type $mol_check_box__title_shm_showcase_demo_dotsloader_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_showcase_demo_dotsloader_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_dotsloader['loading'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_showcase_demo_dotsloader extends $mol_list {
		loading( next?: boolean ): boolean
		Enabled( ): $mol_check_box
		rows( ): readonly(any)[]
		Loader( ): $shm_dotsloader
	}
	
}

//# sourceMappingURL=dotsloader.view.tree.d.ts.map